import request from "../utils/request";
import store from "../store/index"
import { APP_API_BASE_URL } from "../utils/env"
const schemeApi = {
        SchemeList: 'filtrate/add/person',
        patientModule: 'module/patient',
        Confirmed: 'confirmed',
        disgnosis: 'news/diagnosis',
        config: 'config',
        doctor: 'team/doctor',
        deleteFil: 'filtrate/delete/person',
        deleteCon: 'confirmed/delete/patient',
    }
    // 新增慢病患者
export function addPerson(parameter) {
    return request({
        url: schemeApi.SchemeList,
        method: "post",
        data: parameter,

    })
}
// 新增确诊人员
export function addConfirmedPerson(parameter) {
    return request({
        url: schemeApi.Confirmed,
        method: "post",
        data: parameter,
    })
}

export function getPatientModule() {
    return request({
        url: schemeApi.patientModule,
        method: "get",
        params: {},
    })
}

export function getDiagnosis(params) {
    return request({
        url: schemeApi.disgnosis,
        method: "get",
        params: params,
    })
}

export function getConfig(params) {
    return request({
        url: schemeApi.config,
        method: "get",
        params: params,
    })
}

export function getDoctors(params) {
    return request({
        url: schemeApi.doctor,
        method: "get",
        // withoutHeaders: true,
        params: params,
        // headers: {
        //     tenant: store.state.tenant.tenant
        // }
    })
}


export function deleteFiltratePerson(id) {
    return request({
        url: `${schemeApi.deleteFil}/${id}`,
        method: 'delete',
    });
}

export function deleteConfirmedPerson(id) {
    return request({
        url: `${schemeApi.deleteCon}/${id}`,
        method: 'delete',
    });
}